// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__S4VFY","containerItemsCenter":"Skeleton_containerItemsCenter__3Udto"};